import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {fetchDataNew} from "../../hook/axios.hook";

const initialState = {
  requests: [],
  requestFilters: {},
  requestsLoading: false,
  loading: false,
  error: false,
};

export const SYSTEM_STORE_NAME = "warehouse";

export const fetchWarehouseRequestFilters = createAsyncThunk(
  `${SYSTEM_STORE_NAME}/fetchWarehouseRequestFilters`,
  async (params = {}, {signal, rejectWithValue}) =>
    fetchDataNew("/warehouseRequests/filters", "get", {params, signal, rejectWithValue}),
);

export const fetchAllWarehouseRequests = createAsyncThunk(
  `${SYSTEM_STORE_NAME}/fetchAllWarehouseRequests`,
  async (params = {}, {signal, rejectWithValue}) =>
    fetchDataNew("/warehouseRequests/", "get", {params, signal, rejectWithValue}),
);

const getWarehouseRequestsFromPayload = payload => payload?.data ?? [];

const uniqueWarehouseRequests = requests => {
  const ids = new Set();

  return requests.filter(request => {
    const id = request?.warehouseRequestId ?? request?.requestId ?? request?.id;
    if (id == null) return true;
    if (ids.has(id)) return false;
    ids.add(id);
    return true;
  });
};

const systemSlice = createSlice({
  name: SYSTEM_STORE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchWarehouseRequestFilters.fulfilled, (state, {payload}) => {
        state.requestFilters = payload?.data ?? payload ?? {};
      })
      .addCase(fetchAllWarehouseRequests.pending, state => {
        state.requestsLoading = true;
      })
      .addCase(fetchAllWarehouseRequests.fulfilled, (state, {payload, meta}) => {
        const requests = getWarehouseRequestsFromPayload(payload);
        const currentPage = payload?.currentPage ?? payload?.data?.currentPage ?? meta.arg?.page ?? 1;

        state.requests =
          currentPage === 1 ? requests : uniqueWarehouseRequests([...(state.requests || []), ...requests]);
        state.requestsLoading = false;
      })
      .addCase(fetchAllWarehouseRequests.rejected, state => {
        state.requestsLoading = false;
      })

      //fulfilled matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/fulfilled"),
        state => handleFulfilled(state),
      )
      //pending matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/pending"),
        state => handlePending(state),
      )
      //rejected matcher
      .addMatcher(
        action => action.type.startsWith(SYSTEM_STORE_NAME) && action.type.endsWith("/rejected"),
        (state, {error}) => handleRejected(state, error),
      )
      //default
      .addDefaultCase(() => {});
  },
});

const {actions, reducer} = systemSlice;
export default reducer;

export const {smth} = actions;

export const selectWarehouseRequests = state => state[SYSTEM_STORE_NAME].requests;
export const selectWarehouseRequestFilters = state => state[SYSTEM_STORE_NAME].requestFilters;
export const selectWarehouseRequestsLoading = state => state[SYSTEM_STORE_NAME].requestsLoading;

function handleFulfilled(state) {
  state.loading = false;
  state.error = false;
}

function handlePending(state) {
  state.loading = true;
  state.error = false;
}

function handleRejected(state, error) {
  state.loading = false;
  state.error = error;
}
